/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Title from '@cashew/title';
import Box from '@cashew/box';
import List from '@cashew/list';
import './index.css';
import Pagination from '@cashew/pagination';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TFunction } from 'i18next';
import cn from 'classnames';
import { PageWithNavigation, Button } from '../../components';
import { MerchantData } from '../MerchantOnboarding/util';
import OrdersFilter from './OrdersFilter';

const { dateFormat } = require('@cashew/utils');

const ns = 'merchants';

interface StoreItemProps {
  data: MerchantData;
  selected: number;
  t: TFunction;
}

const StoreItem = ({ data, selected, t }: StoreItemProps) => {
  const isSelected = selected === data.id;
  return (
    <div
      className={cn(`${ns}__row`, { [`${ns}__row--selected`]: isSelected })}
      role="row"
      tabIndex={0}
      onKeyDown={undefined}
    >
      <div>
        <p style={{ marginLeft: '12px' }}>{data.id}</p>
      </div>
      <div>
        <p className="three-dots">{data.companyName || t('filed.empty')}</p>
        <p className={`${ns}__row--light three-dots`}>
          {data.representativeFirstName
            ? `${data.representativeFirstName}${
                data.representativeLastName
                  ? ` ${data.representativeLastName}`
                  : ''
              }`
            : t('filed.empty')}
        </p>
      </div>
      <div>{dateFormat({ date: data.createDate || '' })}</div>
      <div>{data.phoneNumber || t('filed.empty')}</div>
      <div>{data.email || t('filed.empty')}</div>
    </div>
  );
};

/**
 * Refunds Page RefundPage
 */
export default () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [merchants, setMerchants] = useState<MerchantData[]>([]);
  const [records, setRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  return (
    <div className={ns}>
      <Helmet>
        <title>{t('merchants.sectionTitle')}</title>
      </Helmet>
      <PageWithNavigation>
        <Title>
          <span>{t('merchants.title')}</span>
          <span>
            <Button
              extraClass="blue show-filter-btn"
              onClick={() => setShowFilter(!showFilter)}
            >
              <div className="btn-with-icon">
                <img src="/fillter.svg" />
                Filters
              </div>
            </Button>
          </span>
        </Title>
        <div className={cn({ 'hide-filter': !showFilter })}>
          <OrdersFilter
            setLoading={setIsLoading}
            useSelector={useSelector}
            page="orders"
            type="cashew"
            setRecords={setRecords}
            setList={setMerchants}
            pageSize={pageSize}
            pageNumber={pageNumber}
            history={history}
            dispatch={dispatch}
            setPageNumber={setPageNumber}
            records={records}
          />
        </div>
        <Box withHeader className={`${ns}__box`}>
          <div>
            <div className={`${ns}__headers`}>
              <p>{t('merchants.table.column.merchantId')}</p>
              <p>{t('merchants.table.column.name')}</p>
              <p>{t('merchants.table.column.registrationDate')}</p>
              <p>{t('merchants.table.column.mobile')}</p>
              <p>{t('merchants.table.column.email')}</p>
            </div>
            <List
              component={StoreItem}
              data={merchants}
              t={t}
              context="merchants"
              isOffline
              isLoading={isLoading}
            />
            <Pagination
              records={records}
              pageSize={pageSize}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              changePageSize={setPageSize}
            />
          </div>
        </Box>
      </PageWithNavigation>
    </div>
  );
};
